import { render } from "./CruciverbaVita.vue?vue&type=template&id=3cae42cd&scoped=true"
import script from "./CruciverbaVita.vue?vue&type=script&lang=js"
export * from "./CruciverbaVita.vue?vue&type=script&lang=js"

import "./CruciverbaVita.vue?vue&type=style&index=0&id=3cae42cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cae42cd"]])

export default __exports__